var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-container d-flex content align-items-center"},[_c('b-navbar-nav',{staticClass:"nav align-items-center ml-auto"},[_c('user-dropdown')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }